export default "__VITE_ASSET__BwxX9tLX__"